var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F3BA2F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.271 10.468 12 6.74l3.73 3.73L17.9 8.3 12 2.4 6.102 8.298l2.17 2.17ZM6.74 12 4.57 9.83 2.4 12l2.17 2.17L6.74 12Zm1.53 1.532L12 17.261l3.73-3.73 2.17 2.167v.002L12 21.6l-5.9-5.898-.003-.003 2.173-2.167Zm11.16.638L21.6 12l-2.17-2.169-2.17 2.17 2.17 2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.2 11.999h.001L12 9.797l-1.627 1.627-.187.187-.385.386-.003.003.003.003 2.2 2.2L14.2 12l.001-.001-.002-.001Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.418180e4627098fb7c048dc89ca506ed.svg";
export { ForwardRef as ReactComponent };